import { render, staticRenderFns } from "./QBranchCard.vue?vue&type=template&id=36604f17&scoped=true"
import script from "./QBranchCard.vue?vue&type=script&lang=js"
export * from "./QBranchCard.vue?vue&type=script&lang=js"
import style0 from "./QBranchCard.vue?vue&type=style&index=0&id=36604f17&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36604f17",
  null
  
)

export default component.exports